module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/school-data/school-data.component.scss
// module id = ./src/app/main/content/pages/management/school-data/school-data.component.scss
// module chunks = main